module.exports = __webpack_public_path__ + "img/huangshanxintou.03fefeba.png";